import { StyleObject } from '@styles-api/css.types'

const ITEM_X_PADDING = 'var(--scale600)'
const ITEM_Y_PADDING = 'var(--scale500)'

const paddingStyles: StyleObject = {
  paddingTop: ITEM_Y_PADDING,
  paddingBottom: ITEM_Y_PADDING,
  paddingLeft: ITEM_X_PADDING,
  paddingRight: ITEM_X_PADDING,
}

export const container = (isShowingMenu: boolean): StyleObject => {
  return {
    backgroundColor: 'var(--base-color)',
    borderRadius: 'var(--radius2)',
    boxShadow: 'var(--card-shadow)',
    padding: isShowingMenu ? 'var(--scale600)' : 'var(--scale400)',
    overflow: 'visible',
    minHeight: isShowingMenu ? 'auto' : '200px',
  }
}

export const card = (isDisabled: boolean): StyleObject => {
  return {
    ...paddingStyles,
    width: '100%',
    flexGrow: 1,
    opacity: isDisabled ? 0.6 : 1,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    pointerEvents: isDisabled ? 'none' : 'auto',
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '140px',
    maxHeight: '140px',
    transition: 'all 0.2s ease-in-out',
    borderRadius: 'var(--radius2)',
    backgroundColor: 'var(--base-color)',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    ':hover': !isDisabled
      ? {
          transform: 'translateY(-1px)',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.12)',
          borderColor: 'var(--primary-color300)',
          backgroundColor: 'var(--shade50)',
          border: '1px solid var(--primary-color300)',
        }
      : {},
    ':active': !isDisabled
      ? {
          transform: 'translateY(0px)',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }
      : {},
  }
}

export const shortDescriptionTip: StyleObject = {
  position: 'absolute',
  zIndex: 'var(--z2)',
  width: '15rem',
  backgroundColor: 'var(--primary-color400)',
  padding: 'var(--scale200)',
  borderRadius: 'var(--radius2)',
  color: 'var(--base-color)',
  opacity: '0.9',
}

export const icon = (isDisabled: boolean): StyleObject => {
  return {
    color: isDisabled ? 'var(--shade300)' : 'var(--primary-color)',
    width: '24px',
    height: '24px',
  }
}
